import Vue from 'vue'
import dialogBoxVue from './DialogBox.vue'

const defaultOptions = {
  title: '',
  content: '',
  contentHtml: '',
  cancelText: '',
  confirmText: '',
  contentClass: '',
  confirmClass: '',
  cancelClass: '',
  showCancel: true
}

let currentMsg, instance
const msgQueue = []
const DialogBoxConstructor = Vue.extend(dialogBoxVue)

const defaultCallback = action => {
  if (currentMsg.resolve && currentMsg.reject) {
    if (action !== 'cancel') {
      currentMsg.resolve(action)
    } else {
      currentMsg.reject(action)
    }
  }
}

const initInstance = () => {
  instance = new DialogBoxConstructor({
    el: document.createElement('div')
  })

  instance.callback = defaultCallback
}

const showNextMsg = () => {
  if (!instance) {
    initInstance()
  }

  if (!instance.value) {
    if (msgQueue.length > 0) {
      currentMsg = msgQueue.shift()

      const options = currentMsg.options
      for (const prop in options) {
        if (options.hasOwnProperty(prop)) {
          instance[prop] = options[prop]
        }
      }
      if (options.callback === undefined) {
        instance.callback = defaultCallback
      }
      document.body.appendChild(instance.$el)

      Vue.nextTick(() => {
        instance.value = true
      })
    }
  }
}

const DialogBox = options => {
  return new Promise((resolve, reject) => {
    msgQueue.push({
      options: Object.assign({}, defaultOptions, options),
      callback: defaultCallback,
      resolve,
      reject
    })

    showNextMsg()
  })
}

export default DialogBox
